import { render, staticRenderFns } from "./view_certificate.vue?vue&type=template&id=08af5b69&scoped=true&"
import script from "./view_certificate.vue?vue&type=script&lang=js&"
export * from "./view_certificate.vue?vue&type=script&lang=js&"
import style0 from "./view_certificate.vue?vue&type=style&index=0&id=08af5b69&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08af5b69",
  null
  
)

export default component.exports